export const useTranslation = async (key: String) => {
    await useNuxtApp().$translations(key);
}